import React from 'react'
import { Box, Typography } from '@mui/material'
import i18next from 'i18next'
import LoadingPage from './LoadingPage'
import { useHome } from '../../hooks/useHome'
const DownloadBrochure = () => {

  const { home: homeData, isLoading } = useHome()
    if (isLoading) return <LoadingPage />
    const { data } = homeData
    let lng = i18next.language
    return (
        <div>
            <Box sx={{
                backgroundColor: '#ff4000cc', 
                borderRadius: 1,
                p: 1,
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                zIndex: 999,
                width: 'max-content',
                textAlign: 'center'
            }} >
                <Typography sx={{ color: '#000' }}>
                    <a href={data?.banner?.[0]?.secondBannerPortfolioBtnLink} 
                        target='_blank'
                        rel="noreferrer"
                        style={{ color: '#fff', textDecoration: "none" }} >
                        {lng === 'en' ? "Download Profile" : "تحميل البروفايل"}
                    </a>
                </Typography>
            </Box>
        </div>
    )
}

export default DownloadBrochure